import React from "react";
import { TransitionGroup } from "react-transition-group";

/**
 * Specification of props available when mounting components before the first
 * route has been emitted.
 */
export type PreRouteRenderProps = {
    /**
     * Optionally supply a transition component, which will be used to apply
     * a fade ouut once the first route is mounted (assuming that rendering of
     * the first route is asynchronous).
     */
    Transition?: React.ComponentType<{ children: React.ReactNode }>;

    /**
     * Specifies if the element should currently be displayed (this value will
     * be supplied by the <Router /> itself, so don't supply it on your own!).
     */
    show?: boolean;

    children?: React.ReactNode;
};

/**
 * Use the <PreRouteRender>-wrapper to mount components until the first matched
 * route emits content.
 */
// tslint:disable-next-line variable-name
export const PreRouteRender: React.FC<PreRouteRenderProps> = ({ Transition, show, children }) => (
    Transition
        ? (
            <TransitionGroup component={ null }>
                { show && <Transition key="preRouteRender">{ children }</Transition> }
            </TransitionGroup>
        )
        : <>{ children }</>
);
